import { useCalendar } from "./context/hook";
import { Periodicity } from "./context/types";
import CalendarFilters from "./components/CalendarFilters";
import EventSidebar from "./components/EventSidebar";
import LinearCalendar from "./components/LinearCalendar";
import MonthlyCalendar from "./components/MonthlyCalendar";
import WeeklyCalendar from "./components/WeeklyCalendar";

export default function Calendar({
  displayTodayButton = true,
}: {
  displayTodayButton?: boolean;
}) {
  const { periodicity, selectedEvent, setSelectedEvent } = useCalendar();

  return (
    <>
      {selectedEvent && (
        <EventSidebar
          isOpen={true}
          onClose={() => setSelectedEvent(null)}
          eventId={selectedEvent.id}
        />
      )}

      <div className="flex flex-col gap-4">
        <CalendarFilters displayTodayButton={displayTodayButton} />
        {periodicity === Periodicity.MONTH && <MonthlyCalendar />}
        {periodicity === Periodicity.QUARTER && <LinearCalendar />}
        {periodicity === Periodicity.WEEK && <WeeklyCalendar />}
      </div>
    </>
  );
}
